module.exports = __webpack_public_path__ + "img/q-studio.b5382b09.png";